export default {"src":"/_next/static/media/notebook.bc5e5772.svg","height":512,"width":512};